<h2 mat-dialog-title class="bg-primary !text-white">Export List</h2>

<mat-dialog-content>
  <p class="pt-4">
    Are you sure you want to export list <span class="font-medium">{{ data.listName }}</span
    >?
  </p>
</mat-dialog-content>

<mat-dialog-actions align="end" class="gap-2 mt-4">
  <button
    mat-flat-button
    (click)="onCancel()"
    [disabled]="isExporting()"
    class="text-gray-600 hover:text-gray-800"
  >
    Cancel
  </button>
  <button
    mat-flat-button
    color="primary"
    (click)="onConfirm()"
    [disabled]="isExporting()"
    class="bg-blue-600 hover:bg-blue-700 text-white min-w-[100px]"
  >
    <span class="flex items-center justify-center">
      <span>Export</span>
      <mat-spinner *ngIf="isExporting()" diameter="20" class="ml-2"> </mat-spinner>
    </span>
  </button>
</mat-dialog-actions>
